export const currentTemplateStorageKey = 'smartix.currentTemplateId'
export const getCurrentTemplateId = () => typeof window === 'undefined' ? '' : window.localStorage.getItem(currentTemplateStorageKey) || ''
export const setCurrentTemplateId = templateId => {
  if (typeof window !== 'undefined' && templateId) window.localStorage.setItem(currentTemplateStorageKey, templateId)
}
